import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarSimpleRightWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sidebar-simple-right-wide"><path fillRule="evenodd" clipRule="evenodd" d="M15 5.5V18.5H5.75C4.50736 18.5 3.5 17.4926 3.5 16.25V7.75C3.5 6.50736 4.50736 5.5 5.75 5.5H15ZM22 7.75C22 5.67893 20.3211 4 18.25 4H5.75C3.67893 4 2 5.67893 2 7.75V16.25C2 18.3211 3.67893 20 5.75 20H18.25C20.3211 20 22 18.3211 22 16.25V7.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSidebarSimpleRightWide;
